// Vendor
import * as React from 'react';
import { BarSvgProps, ResponsiveBar } from '@nivo/bar';
import { useInView } from 'react-intersection-observer';
import { SPOT_BRAND } from '@thredup/styleguide/src/variables/colors';

// Internal
import { Bar } from './Bar';
import { data } from './data';
import { DEFAULT_CHART_PROPS } from '@src/config/nivo';

const ChartConsumersPrioritize: React.FC = () => {
  // Hooks
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '-200px 0px'
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const initialData = data.map((d: any) => ({
    ...d,
    more: 1,
    less: -1
  }));

  const chartData = inView ? data : initialData;
  const colors = { more: SPOT_BRAND, less: '#fdbd55' };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getColors = (bar: any) => (colors as any)[bar.id];

  const barProps: BarSvgProps = {
    ...DEFAULT_CHART_PROPS,
    axisLeft: {
      format: () => '',
      tickPadding: 10,
      tickSize: 160,
      tickValues: [0]
    },
    barComponent: Bar,
    colors: getColors,
    data: chartData,
    enableGridY: true,
    gridYValues: [0],
    indexBy: 'sector',
    keys: ['less', 'more'],
    margin: { top: 80, right: 0, bottom: 30, left: 160 },
    maxValue: 45,
    minValue: -66,
    padding: 0.6
  };

  return (
    <span ref={ref}>
      <ResponsiveBar {...barProps} />
    </span>
  );
};

export { ChartConsumersPrioritize };
